import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({
  relationshipFilter,
  onRelationshipFilterChange,
  selectedAct,
  onActChange,
  playId
}) => {
  const relationshipTypes = [
    { value: 'all', label: 'All Relationships', icon: 'Users', color: 'text-primary' },
    { value: 'strong', label: 'Strong Bonds (3+ scenes)', icon: 'Heart', color: 'text-red-500' },
    { value: 'weak', label: 'Weak Connections (<3 scenes)', icon: 'Link', color: 'text-slate-400' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-muted-foreground" />
        <h3 className="font-semibold text-foreground">Filter Network</h3>
      </div>

      <div className="space-y-4">
        {/* Relationship Type Filter */}
        <div>
          <label className="block text-sm font-medium text-muted-foreground mb-2">
            Relationship Strength
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            {relationshipTypes?.map(type => (
              <button
                key={type?.value}
                onClick={() => onRelationshipFilterChange(type?.value)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg border transition-all ${
                  relationshipFilter === type?.value
                    ? 'bg-primary text-primary-foreground border-primary'
                    : 'bg-background border-border hover:border-primary/50 text-foreground'
                }`}
              >
                <Icon name={type?.icon} size={16} className={relationshipFilter === type?.value ? '' : type?.color} />
                <span className="text-sm font-medium">{type?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Info */}
        <div className="flex items-start gap-2 p-3 bg-muted rounded-lg">
          <Icon name="Info" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            Filter characters by the strength of their relationships based on shared scene appearances. Strong bonds indicate frequent interactions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;